import { z } from 'zod';
import { BaseSchema } from './BaseSchema';
import { S3FileSchema } from './S3File';
export var UserSchema = BaseSchema.extend({
    preSignupToken: z.string().optional(),
    emailConfirmationToke: z.string().optional(),
    passwordRecoveryToken: z.string().optional(),
    name: z.string().min(1),
    email: z.string().email(),
    password: z.string(),
    pictureFile: z.union([z.string(), S3FileSchema]).optional(),
    root: z.boolean(),
    rootRoles: z.string().array(),
    parentUser: z.union([z.string(), z.any()]).optional(),
    phone: z.string().optional()
});
